import './AdminLayout.scss';
import React, { PropsWithChildren } from 'react';
import { LayoutBreadcrumb } from 'src/modules/common/components/LayoutBreadcrumb';
import { AppLayout } from 'src/modules/common/layouts/AppLayout';

type Props = PropsWithChildren<{
  actions?: React.ReactNode;
  extension?: React.ReactNode;
  breadcrumbs: React.ReactNode;
  title: string;
}>;

export const AdminLayout = ({
  actions,
  children,
  extension,
  title,
  breadcrumbs,
}: Props): React.ReactElement => (
  <AppLayout className="bp-admin-layout">
    <div className="bp-admin-layout__header-wrapper">
      <div className="bp-admin-layout__header-content">
        <header className="bp-admin-layout__header">
          <LayoutBreadcrumb>
            {breadcrumbs}
          </LayoutBreadcrumb>

          <h1 className="bp-admin-layout__header-title">{title}</h1>
          <div className="bp-admin-layout__header-actions">{actions}</div>
        </header>

        <div className="bp-admin-layout__header-extensions">
          {extension}
        </div>
      </div>
    </div>

    {children}
  </AppLayout>
);
